import React, { Component } from 'react';
import { Input, Form } from 'antd';

const { TextArea } = Input;
const FormItem = Form.Item;

class TextAreaCustom extends Component {
    render() {
        const {label, marginBottom, labelColor, placeholder, rows, resize, autosize, name , ...rest } = this.props
        return (
            <FormItem label={label} className={`form-label margin-bottom${marginBottom} label-color${labelColor}`}>
                <TextArea 
                    { ...rest }
                    rows={rows} 
                    className={`textarea ${resize ? 'resize' : 'none-resize'}`}
                    placeholder={placeholder} 
                    name={name}
                    autosize={autosize}
                    />
            </FormItem>
        );
    }
}

export default TextAreaCustom;
